export const BP_FOOTER_EL_ID = 'bpFooter';
